module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.11eabca2.ttf";